module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-1.5426f3e0.jpg";